module.exports = __webpack_public_path__ + "img/8B7469_443E39_C7A797_544443-256px.8269389b.png";